// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"youtube_wrapper__WECce","player":"youtube_player__pq78y"};